import { ChipGroup } from '@storeblocks/chip';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { AllocationType } from '@/pages/Presentation/types/AllocationType';
import { TrackingElement, useGetTrackId } from '@/tracking';

interface Props {
  checked: AllocationType;
  onChange(selectedAllocationType: AllocationType): void;
}

export const AllocationTypeChips: FC<Props> = ({ checked, onChange }) => {
  const texts = useTexts();

  const getTrackId = useGetTrackId();
  const trackId = getTrackId(
    'select-allocation-type',
    TrackingElement.FilterChip,
  );

  return (
    <ChipGroup
      id="allocation-type-chips"
      chipVariant="choice"
      options={[
        {
          id: 'main-distribution',
          label: texts.charts.filters.allocationTypes.mainDistribution,
          value: AllocationType.MainDistribution,
          inputProps: {
            'data-trackid': trackId,
            'data-trackid-selected-filter': 'main-distribution',
            'data-trackid-source': 'asset-allocation-donut',
            'data-trackid-type': 'filter-chips',
          },
        },
        {
          id: 'product-group',
          label: texts.charts.filters.allocationTypes.productGroups,
          value: AllocationType.ProductGroup,
          inputProps: {
            'data-trackid': trackId,
            'data-trackid-selected-filter': 'product-groups',
            'data-trackid-source': 'asset-allocation-donut',
            'data-trackid-type': 'filter-chips',
          },
        },
        {
          id: 'product',
          label: texts.charts.filters.allocationTypes.products,
          value: AllocationType.Product,
          inputProps: {
            'data-trackid': trackId,
            'data-trackid-selected-filter': 'products',
            'data-trackid-source': 'asset-allocation-donut',
            'data-trackid-type': 'filter-chips',
          },
        },
      ]}
      checked={[checked]}
      onChange={(value) => onChange(value[0] as AllocationType)}
    />
  );
};
